import IndexesPage from "@/components/marketing/products/indexes/IndexesPage"

type Props = {}

const index = (_props: Props) => {
  return <IndexesPage />
}

export default index
